import styled from 'styled-components';
import { Text, TextHighlight } from '../shared/Text';
import { StatsBase } from '../../types/TixAPITypes';
import { FlexColMiddle, FlexRowMiddle } from '../shared/Flex';
import { formatCurrency } from '../../scripts/scripts';
import { TextSkeleton } from '../shared/Skeleton';
import { ReactNode } from 'react';

const HeaderTitle = styled(FlexColMiddle)`
	row-gap: 0.5rem;
`;

const HeaderStatistic = styled(HeaderTitle)`
	align-items: flex-start;
`;

const StyledOSHeaderStats = styled(FlexRowMiddle)`
	width: 100%;
	max-width: 600px;
	display: grid;
	grid-template-columns: 3fr 2fr 2fr 2fr;
`;

export const OSHeaderTitle = styled(FlexColMiddle)`
	row-gap: 0.5rem;
`;

export function OSStatsHeader({ stats, showToBeSold }: { stats?: StatsBase; showToBeSold?: boolean }) {
	return (
		<StyledOSHeaderStats className='eventStatsDesktop'>
			<HeaderStatistic>
				<Text $color="text_desc_alt" $size="1.6rem" $weight="400">
					<TextHighlight
						$color={
							!stats || !stats.totalROI
								? 'text_title_main'
								: stats.totalROI > 0
									? 'text_green'
									: 'text_red'
						}
					>
						<TextSkeleton width="20px" height="13px">
							{!stats ? undefined : stats.totalROI === null ? '0%' : `${stats.totalROI.toFixed(0)}%`}
						</TextSkeleton>
					</TextHighlight>{' '}
					ROI
				</Text>
				<Text $color="text_desc_alt" $size="1.4rem" $weight="400">
					<TextHighlight
						$color={
							!stats || stats.totalProfit === 0
								? 'text_title_main'
								: stats.totalProfit > 0
									? 'text_green'
									: 'text_red'
						}
					>
						~
						<TextSkeleton width="20px" height="13px">
							{!stats ? undefined : formatCurrency(stats.totalProfit, 'EUR')}
						</TextSkeleton>
					</TextHighlight>{' '}
					Profit
				</Text>
			</HeaderStatistic>
			<SubStat label={showToBeSold ? ' To Sell' : ' Unsold'}>
				{!stats
					? undefined
					: showToBeSold
						? formatCurrency(stats.totalValueToBeSold, 'EUR')
						: formatCurrency(stats.totalValueUnsold, 'EUR')}
			</SubStat>
			<SubStat label="Sold">{!stats ? undefined : `${formatCurrency(stats.totalSoldAll, 'EUR')}`}</SubStat>
			<SubStat label="Value of Sold">
				{!stats ? undefined : `${formatCurrency(stats.totalValueSoldAll, 'EUR')}`}
			</SubStat>
		</StyledOSHeaderStats>
	);
}

function SubStat({ label, children }: { label: string; children: ReactNode }) {
	return (
		<HeaderStatistic>
			<FlexColMiddle style={{ rowGap: '0.5rem' }}>
				<Text $color="text_title_main" $size="1.6rem" $weight="400">
					<TextSkeleton width="20px" height="13px">
						{children}
					</TextSkeleton>
					~
				</Text>
				<Text $color="text_title_alt" $size="1.4rem" $weight="400">
					{label}
				</Text>
			</FlexColMiddle>
		</HeaderStatistic>
	);
}
